import { API, API_GET } from "../../../Config"


export const GetQuestions = () => {
  return (
    API_GET(API.GetQuestions)
  )
}

